<template>
  <mk-drawer-biz-two
    class="add-course-exam-drawer"
    :visible="visible"
    :append-to-body="false"
    :modal-append-to-body="false"
    :title="title"
    size="1000px"
    confirm-text="添 加"
    @open="handelOnDrawerOpen"
    @close="cancel"
    @cancel="cancel"
    @confirm="handelOnDrawerConfirm"
  >
    <!-- header 头部区域 -->
    <template slot="title">
      <span class="drawer-biz-title">{{ '新增' + title }}
      </span>
    </template>
    <!-- 中间区域 -->
    <mk-tabs-biz
      v-model="activeName"
      class="el-tabs-mk-ui-mini"
    >
      <mk-tab-pane
        label="内部课程"
        name="inside"
      >
      </mk-tab-pane>
      <mk-tab-pane
        :label="collegeName"
        name="outside"
      >
      </mk-tab-pane>
    </mk-tabs-biz>
    <list-biz
      v-if="activeName === 'inside'"
      :choose-list="chooseList"
      :config="config"
      :data="listData"
      :total="total"
      :page="params.page"
      @on-search-change="hanldeOnSearchClick"
      @on-reset-change="hanldeOnResetClick"
      @on-select-change="handleOnSelectChange"
      @on-current-change="handleOnCurrentChange"
    />
    <div
      v-if="activeName === 'outside'"
      class="search-handle-line"
    >
      <tag-select
        v-model="outParams.tags"
        :api="api"
        width="200"
        :tip="false"
        class="tag-select-components"
      />
      <mk-input
        v-model="outParams.name"
        class="name"
        width="200px"
        placeholder="请输入名称"
      />
      <mk-button
        icon="el-icon-search"
        class="search-btn"
        type="primary"
        size="small"
        @click="search"
      >
        搜索
      </mk-button>
      <mk-button
        class="reset-btn"
        size="small"
        @click="reset"
      >
        重置
      </mk-button>
    </div>
    <list-biz
      v-if="activeName === 'outside'"
      :tip="false"
      class="outside"
      :choose-list="chooseList"
      :config="outConfig"
      :data="outListData"
      :total="outTotal"
      :page="outParams.page"
      @on-select-change="outHandleOnSelectChange"
      @on-current-change="outHandleOnCurrentChange"
    />
    <!-- 底部操作 -->
    <template
      slot="bottom"
    >
      <mk-button
        size="small"
        @click="cancel"
      >
        取消
      </mk-button>
      <mk-button
        size="mini"
        type="primary"
        @click="handleOnAddClick"
      >
        添加
      </mk-button>
    </template>
  </mk-drawer-biz-two>
</template>
<script>
import MkDrawerBizTwo from '@components/mk-drawer-biz-two'
import ListBiz from '@/views/smart-name-card/components/list'
import ListTableColumnTag from '@/components/list-table-column-tag/index.vue'
import tagSelect from '@components/tag-select'
import { MBASVCAPIS } from '@api'
export default {
  components: {
    MkDrawerBizTwo,
    ListBiz,
    tagSelect
  },
  props: {
    collegeName: {
      type: [String, Number],
      default: ''
    },
    chooseList: {
      type: Array,
      default () {
        return []
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      listData: [],
      outListData: [],
      total: 0,
      outTotal: 0,
      params: {
        name: '',
        page: 1,
        pageSize: 10,
        status: 1,
        tags: []
      },
      outParams: {
        name: '',
        page: 1,
        pageSize: 10,
        status: 1,
        tags: []
      },
      config: {
        mode: 'table',
        form: {
          input: {
            show: true,
            placeholder: '请输入名称',
            value: null
          },
          tags: {
            show: true,
            data: [],
            value: null
          }
        },
        list: {
          type: 'table',
          columns: [
            {
              selection: true
            },
            {
              prop: 'name',
              label: '课程名称',
              // 自定义组件
              component: null,
              showOverflowTooltip: true
            },
            {
              prop: 'tags',
              label: '标签',
              // 自定义组件
              component: ListTableColumnTag,
              width: '220px'
            },
            {
              prop: 'description',
              label: '课程说明',
              // 自定义组件
              component: null,
              showOverflowTooltip: true
            },
            {
              prop: 'courseWaresAmount',
              label: '课件数',
              // 自定义组件
              component: null
            },
            {
              prop: 'creator',
              label: '创建人',
              // 自定义组件
              component: null
            },
            {
              prop: 'createTime',
              label: '创建时间',
              // 自定义组件
              component: null
            }
          ]
        }
      },
      outConfig: {
        mode: 'table',
        list: {
          type: 'table',
          columns: [
            {
              selection: true
            },
            {
              prop: 'name',
              label: '课程名称',
              // 自定义组件
              component: null,
              showOverflowTooltip: true
            },
            {
              prop: 'showTags',
              label: '标签',
              // 自定义组件
              component: ListTableColumnTag,
              width: '220px'
            },
            {
              prop: 'description',
              label: '课程说明',
              // 自定义组件
              component: null,
              showOverflowTooltip: true
            },
            {
              prop: 'courseWaresAmount',
              label: '课件数',
              // 自定义组件
              component: null
            }
          ]
        }
      },
      result: [],
      outResult: [],
      activeName: 'inside',
      api: {
        name: TAGSVCAPIS.PlatformApi.v1TagPlatformListEnableCompanyGet,
        params: {}
      }
    }
  },
  watch: {
    activeName (val) {
      if (val === 'inside') {
        this.getList()
      } else if (val === 'outside') {
        this.outGetList()
      }
    }
  },
  created () {
    this.getList()
    this.outGetList()
  },
  methods: {
    search () {
      this.outGetList()
    },
    reset () {
      this.outParams = {
        name: '',
        page: 1,
        pageSize: 10,
        status: 1,
        tags: []
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    hanldeOnSearchClick (data) {
      this.params = {
        name: data.title,
        page: 1,
        pageSize: 10,
        status: 1,
        tags: data.tags
      }
      this.getList()
    },
    hanldeOnResetClick () {
      this.config.form = {
        input: {
          show: true,
          placeholder: '请输入名称'
        },
        tags: {
          show: true,
          data: []
        }
      }
      this.params = {
        page: 1,
        pageSize: 10,
        status: 1
      }
    },
    handleOnSelectChange (data) {
      let arr = []
      data.forEach((item, index) => {
        arr.push({
          ...item,
          type: 1
        })
      })
      this.result = arr
    },
    outHandleOnSelectChange (data) {
      let arr = []
      data.forEach((item, index) => {
        arr.push({
          ...item,
          type: 3
        })
      })
      this.result = arr
    },
    handelOnDrawerConfirm () {
      this.handleOnAddClick()
    },
    handleOnAddClick () {
      if (this.result && this.result.length > 0) {
        this.$emit('confirm', this.result)
      } else {
        this.$message({
          type: 'error',
          message: '请至少选择一个课程',
          showClose: true
        })
      }
    },
    handelOnDrawerOpen () {
      this.getList()
    },
    handleOnCurrentChange (e) {
      this.result = []
      this.params.page = e
      this.getList()
    },
    outHandleOnCurrentChange (e) {
      this.outResult = []
      this.outParams.page = e
      this.outGetList()
    },
    async getList () {
      const { success, data, total } = await MBASVCAPIS.CourseApi.courseListPost({
        ...this.params
      })
      if (success) {
        this.listData = data.data
        this.total = data.total
      }
    },
    async outGetList () {
      const { success, data, total } = await MBASVCAPIS.CourseClientApi.courseSystemCourseListPost({
        ...this.outParams
      })
      if (success) {
        this.outListData = data.data
        this.outTotal = data.total
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.add-course-exam-drawer {
  .drawer-biz-title {
    font-weight: 500;
  }

  /deep/ .list-biz.outside {
    height: calc(100% - 102px);
  }

  /deep/ .list-biz {
    height: calc(100% - 48px);
  }

  /deep/ .drawer-content {
    .el-tabs {
      width: calc(100% + 40px);
      margin: -10px  0 10px -20px;
    }
  }

  /deep/ .el-table {
    thead {
      .el-table-column--selection {
        .el-checkbox {
          display: none !important;
        }
      }
    }
  }

  .search-handle-line {
    display: flex;
    margin-bottom: 5px;

    .name {
      width: 240px;
      margin: 0 16px 0 10px;
    }

    /deep/ .el-select {
      line-height: 32px !important;

      .el-input__inner {
        line-height: 32px !important;
      }
    }
  }

  .search-btn,
  .reset-btn {
    height: 32px !important;
    flex-shrink: 0;
  }

  /deep/ .el-select {
    margin-top: 0;
  }
}
</style>
